import React from 'react';

const About = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
      {/* Hero Section */}
      <div className="text-center mb-12 lg:mb-16">
        <h1 className="text-2xl lg:text-3xl font-light tracking-tight text-gray-900">
          About
        </h1>
        <div className="w-12 h-px bg-gray-300 mx-auto mt-4 mb-6"></div>
        <p className="text-sm text-gray-500 max-w-lg mx-auto">
          We believe in thoughtful design, quality materials, and timeless style.
        </p>
      </div>

      {/* Our Story */}
      <div className="mb-12">
        <h2 className="text-xs font-light tracking-wide uppercase text-gray-400 mb-4">
          Our Story
        </h2>
        <p className="text-sm text-gray-500 leading-relaxed mb-4">
          Founded in 2024, STUDIO was born from a simple idea: create clothing that 
          transcends seasons and trends. What started as a small passion project has 
          grown into a destination for those who appreciate minimalist design and 
          exceptional quality.
        </p>
        <p className="text-sm text-gray-500 leading-relaxed">
          Every piece in our collection is thoughtfully designed with attention to 
          detail, using carefully sourced materials. We believe that less is more, 
          and that a well-curated wardrobe should bring you joy every day.
        </p>
      </div>

      {/* Mission */}
      <div className="mb-12">
        <h2 className="text-xs font-light tracking-wide uppercase text-gray-400 mb-4">
          Our Mission
        </h2>
        <p className="text-sm text-gray-500 leading-relaxed">
          To create enduring pieces that you'll reach for season after season. 
          We're committed to thoughtful production, quality craftsmanship, and 
          designs that prioritize both form and function.
        </p>
      </div>

      {/* Values */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-12 py-4">
        <div>
          <h3 className="text-sm font-light tracking-wide text-gray-900 mb-2">
            Quality
          </h3>
          <p className="text-xs text-gray-400 leading-relaxed">
            Premium materials and careful construction ensure each piece lasts.
          </p>
        </div>
        <div>
          <h3 className="text-sm font-light tracking-wide text-gray-900 mb-2">
            Simplicity
          </h3>
          <p className="text-xs text-gray-400 leading-relaxed">
            Clean lines, neutral palettes, and timeless silhouettes.
          </p>
        </div>
        <div>
          <h3 className="text-sm font-light tracking-wide text-gray-900 mb-2">
            Integrity
          </h3>
          <p className="text-xs text-gray-400 leading-relaxed">
            Transparent practices and ethical production standards.
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-100 my-12"></div>

      {/* Contact */}
      <div>
        <h2 className="text-xs font-light tracking-wide uppercase text-gray-400 mb-4">
          Contact
        </h2>
        <div className="space-y-2">
          <p className="text-sm text-gray-500">
            Email:{' '}
            <a href="mailto:info@studio.com" className="text-gray-900 hover:text-gray-600 transition">
              info@studio.com
            </a>
          </p>
          <p className="text-sm text-gray-500">
            Phone:{' '}
            <a href="tel:+85512345678" className="text-gray-900 hover:text-gray-600 transition">
              +855 12 345 678
            </a>
          </p>
          <p className="text-sm text-gray-500">
            Studio: 123 Minimal Street, Phnom Penh, Cambodia
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;